export const GREEN = '#4CAF50';
export const RED = '#F44336';